var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { AssetsList } from "../store/types";
import { isProduction } from "../utils/env";
import { defaultAssetTickerData, } from "./externalAPIDataContext";
import { COINGECKO_BASE_URL, COINGECKO_CURRENCIES, getAssets, VaultList, } from "../constants/constants";
var getTickerData = function (currencyName) { return __awaiter(void 0, void 0, void 0, function () {
    var apiURL, response, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                apiURL = COINGECKO_BASE_URL + "/simple/price?ids=" + currencyName + "&vs_currencies=usd&include_24hr_change=true";
                return [4 /*yield*/, axios.get(apiURL)];
            case 1:
                response = _a.sent();
                data = response.data;
                return [2 /*return*/, {
                        usd: data[currencyName].usd,
                        dailyChange: data[currencyName].usd_24h_change,
                    }];
        }
    });
}); };
export var useTickerData = function (_a) {
    var _b = _a === void 0 ? { poll: true, pollingFrequency: 120000 } : _a, poll = _b.poll, pollingFrequency = _b.pollingFrequency;
    var _c = useState(defaultAssetTickerData), data = _c[0], setData = _c[1];
    var _d = useState(true), loading = _d[0], setLoading = _d[1];
    // Show only vault-based assets
    var excludedAssets = [];
    VaultList.map(function (vault) {
        excludedAssets.push(getAssets(vault));
    });
    var fetchAssetTickers = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var responses;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isProduction()) {
                        console.time("Ticker Data Fetch");
                    }
                    return [4 /*yield*/, Promise.all(__spreadArray([], AssetsList).filter(function (asset) { return excludedAssets.includes(asset); })
                            .map(function (asset) { return __awaiter(void 0, void 0, void 0, function () {
                            var currencyName, _a;
                            var _b;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        currencyName = COINGECKO_CURRENCIES[asset];
                                        _b = {
                                            asset: asset
                                        };
                                        if (!currencyName) return [3 /*break*/, 2];
                                        return [4 /*yield*/, getTickerData(currencyName)];
                                    case 1:
                                        _a = _c.sent();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        _a = {
                                            usd: 0,
                                            dailyChange: 0,
                                        };
                                        _c.label = 3;
                                    case 3: return [2 /*return*/, (_b.data = _a,
                                            _b)];
                                }
                            });
                        }); }))];
                case 1:
                    responses = _a.sent();
                    setData(Object.fromEntries(responses.map(function (response) { return [
                        response.asset,
                        {
                            asset: response.asset,
                            price: response.data.usd,
                            dailyChange: response.data.dailyChange,
                        },
                    ]; })));
                    setLoading(false);
                    if (!isProduction()) {
                        console.timeEnd("Ticker Data Fetch");
                    }
                    return [2 /*return*/];
            }
        });
    }); }, []);
    useEffect(function () {
        fetchAssetTickers();
        var pollInterval = undefined;
        if (poll) {
            pollInterval = setInterval(fetchAssetTickers, pollingFrequency);
        }
        return function () {
            if (pollInterval) {
                clearInterval(pollInterval);
            }
        };
    }, [fetchAssetTickers, poll, pollingFrequency]);
    return { data: data, loading: loading };
};
//# sourceMappingURL=useTickerData.js.map